import { defineComponent as r, computed as l, openBlock as a, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as f, normalizeStyle as h } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "aa6875a5-03f2-417b-a94b-ab93bfbbfc1e" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#aa6875a5-03f2-417b-a94b-ab93bfbbfc1e)" }, v = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M71 0 0 34v91l16 35-16 36v60l256 64 256-64v-60l-16-36 16-35V34L441 0h-85l-32 16-32-16h-72l-32 16-32-16Z"
}, null, -1), k = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 256h512v256H0Z"
}, null, -1), b = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m292 0-36 256L356 0h-64zm-36 256L512 34V0h-71L256 256zm0 0 256-60v-71L256 256zm0 0L0 125v71l256 60zm0 0L71 0H0v35l256 221zm0 0L220 0h-64l100 256z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#ff9811",
  d: "m256 128 83 256-217-159h268L173 384Z"
}, null, -1), z = { fill: "none" }, L = ["r"], W = /* @__PURE__ */ r({
  __name: "us-az",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const t = c, o = l(() => 512 + 2 * t.strokeWidth), s = l(() => -t.strokeWidth), n = l(() => 256 + t.strokeWidth / 2);
    return (x, w) => (a(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (a(), i("title", v, d(t.flagName), 1)) : f("", !0),
        p,
        k,
        b,
        g
      ]),
      e("g", z, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: h({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, L)
      ])
    ], 8, _));
  }
});
export {
  W as default
};
//# sourceMappingURL=us-az-96e16ac5.js.map
